import React from 'react';
import styles from '../OrderStatus.module.css';
import buttonStyles from '../../../styles/buttons.module.css';
import { useStates } from '../../../hooks/StatesContext';
import { CircularProgress } from '@mui/material';
import Render from '../../Render';

const BillingDetails = (props) => {

  const states = useStates();
  const [stateAbbreviation, setStateAbbreviation] = React.useState('');

  React.useEffect(() => {
    if (states.length > 0) {
      const state_abv = states.find(state => state.state_id === props.order.purchase_card_state_id)?.state_abbreviation;

      if (state_abv) {
        setStateAbbreviation(state_abv);
      }
    }
  }, [states]);

  return (
    <>
      <div className='row'>
        <div className='col-sm-5'>
          <h2 className={styles.heading}>BILLING INFORMATION</h2>
        </div>
      </div>
      {props.order.is_warranty ?
        <div className='row'>
          <div className='col-sm-4'>
            <h3>Warranty Order</h3>
          </div>
        </div>
      :
        <div className='row'>
          <div className='col-sm-4'>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
              <h3>Card Info</h3>
              {props.getCreditCardUsedOnOrderMeta.loading && <CircularProgress size={20} />}
            </div>
            <p>{props.creditCard.number}</p>
            <p>{props.creditCard.expiration}</p>
            <p>{props.creditCard.type}</p>
          </div>
          <div className='col-sm-6'>
            <h3>Billing Address</h3>
            <p>{props.order.purchase_card_name}</p>
            <p>{props.order.purchase_card_company}</p>
            <p>{props.order.purchase_card_address_1}</p>
            <p>{props.order.purchase_card_city + ', ' + stateAbbreviation + ' ' + props.order.purchase_card_zip}</p>
          </div>
        </div>
      }
    </>
  );
};

export default BillingDetails;